import Edit from "@mui/icons-material/Edit";
import { IconButton, Tooltip } from "@mui/material";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import type { UUID } from "../../../../utils/uuid";

export const EditAction: FC<{ id: UUID | null; title: string | null }> = ({ id, title }) => {
  const { t } = useTranslation();

  return (
    <Tooltip title={t("Edit Communication: {{title}}", { title })}>
      <IconButton data-analytics-id="moment-card-edit" href={`/moments/${id || ""}`}>
        <Edit fontSize="small" sx={{ marginLeft: 0 }} data-testid="moment-edit-icon" />
      </IconButton>
    </Tooltip>
  );
};
